import React from 'react';

export default function NewPostHoc (WrappedComponent) {
  return class extends React.Component {
    state = {
      open: false,
      uncroppedImages: [],
      croppedImage: null,
      crop: [
        {
          width: 600,
          height: 472,
          aspect: 1.272 / 1
        }
      ],
      saving: false
    }

    counter = (input, limit = 200) => {
      return limit - input.validations.val.length;
    };

    dismiss = bool => {
      this.setState({ dismiss: bool });
    };

    dismissAndClose = () => {
      this.setState({ dismiss: false });
      this.props._social.newPost(null);
    };

    handleImage = images => {
      this.setState({ uncroppedImages: [images] });
    };

    imageToState = image => {
      this.setState({ uncroppedImages: [], croppedImage: image });
    };

    removeImage = () => {
      this.setState({ croppedImage: null });
    };

    save = () => {
      this.setState({ saving: true });
      this.props._social
        .savePost(this.props.inputs, this.state.croppedImage)
        .then(res => this.props._social.newPost(null));
    };

    render() {
      return <WrappedComponent 
        {...this.props}
        counter={this.counter}
        crop={this.state.crop}
        croppedImage={this.state.croppedImage}
        dismiss={this.dismiss}
        dismissAndClose={this.dismissAndClose}
        handleImage={this.handleImage}
        imageToState={this.imageToState}
        open={this.state.dismiss}
        removeImage={this.removeImage}
        save={this.save}
        saving={this.state.saving}
        uncroppedImages={this.state.uncroppedImages} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Social/NewPostHoc.js